import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import HeroSection from './components/hero-section/hero-section';
import Banner from './components/banner/banner';
import MobileBanner from './components/banner/mobileBanner';
import PromoBanner from './components/promo-banner/PromoBanner';
import Trending from './components/Trending/Trending';
import Testimonial from './components/testimonial/testimonial';
import Banner2 from './components/banner2/banner2';
import useLoginModal from '../login/useLoginModal';
import { authenticateUser, getCurrentUser } from '../login/api';

const LandingPage = () =>{

  const location = useLocation();
  const loginModal = useLoginModal();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const token = params?.get('token');

  const { userData } = useSelector((state) => state.app);
  const { trendingEvents, primaryEvents } = useSelector((state) => state.landingPage);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    if (token) {
      authenticateUser(token, () => {
        getCurrentUser();
      });
    }
  }, [token]);

  useEffect(() => {
    if (userData?.email && token) {
      if (!userData?.name) loginModal.onOpen();
    }
  }, [userData]);

  return (
    <>
      <Helmet>
        <title>TakeMyTickets: Buy and sell concert tickets in India</title>
        <meta name="robots"
          content="index, follow" />
        <meta
          name="description"
          content="Discover Take My Tickets, the leading ticket resale website in India. Buy and sell event tickets securely and conveniently."
        />
      </Helmet>
      {/* <LocationModal/> */}
      <HeroSection />
      {/* {window.innerWidth < 600 ? (
        <MobileBanner
          id="Know_more"
          heading={`Looking for a Better \n Ticketing Option?`}
          subtitle="Lowest fees and tailored features for your events!"
          label="List your event"
        />
      ) : (
        <Banner />
      )} */}
      <PromoBanner />
      <Trending 
        title="Popular events around you" 
        btnLabel="View more events"
        placeholder="No popular events around you"
        trendingEvents={primaryEvents}
      />
      <Trending
        title="Verified Resale tickets! 🔥 "
        btnLabel="View more resale events"
        trendingEvents={trendingEvents}
        resale={true}
        isBanner={true}
      />
      <Testimonial />
      <Banner2 />
    </>
  );
}

export default LandingPage;
